import React from 'react'
import {Grid, Typography} from '@material-ui/core'
import ReceiptRoundedIcon from '@material-ui/icons/ReceiptRounded'

import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineContent from '@material-ui/lab/TimelineContent'

import CustomTimeline, {
  CustomTimelineSeparator,
} from '../../components/Timeline/Timeline'

import resumeData from '../../utils/resumeData'
import './Publication.css'
import 'react-notifications-component/dist/theme.css'

const Publication = () => {
  return (
    <>
      {/* Education and Experiences */}
      <Grid item xs={12} className="section">
        <Grid container className="resume-timeline">
          {/* Experiences */}
          <div className="publication">
            <Grid item sm={12} md={12}>
              <CustomTimeline
                title="Published and Under Review Manuscripts"
                icon={<ReceiptRoundedIcon />}
              >
                {resumeData.publications.map(publication => (
                  <TimelineItem>
                    <CustomTimelineSeparator />
                    <TimelineContent className="timeline-content">
                      <Typography className="timeline-title">
                        {publication.title}
                      </Typography>
                      <Typography variant="caption" className="timeline-date">
                        {publication.date}{' '}
                        <span>
                          <a href={publication.link}>
                            {publication.description}
                          </a>
                        </span>
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </CustomTimeline>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default Publication
